import { CircularProgress, styled } from "@mui/material";

const ContainerStyled = styled("div")({
  label: "loader-container",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  height: "100%",
  width: "100%",
});

const LoaderUnstyled = ({ size = 20, color, className }) => {
  return (
    <ContainerStyled className={className}>
      <CircularProgress
        size={size}
        sx={{ color }}
        className="circular-progress"
      />
    </ContainerStyled>
  );
};

const Loader = styled(LoaderUnstyled)({});

export default Loader;
